import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ListLiquidaciones from './Components/ListLiquidaciones';
import LiquidacionNew from './Components/LiquidacionNew';
import EditarLiquidacion from './Components/EditarLiquidacion';
import EditarLiquidacionBorrador from './Components/EditarLiquidacionBorrador';
import ActualizacionMasivaLiquidaciones from './Components/Excel/ActualizacionMasivaLiquidaciones';
import FeeNew from './Components/FeeNew';
import ComprobantesLiquidaciones from './Components/ComprobantesLiquidaciones';
import LiquidacionesPipelinesDashboard from './Components/LiquidacionesPipelinesDashboard';
import LiquidacionPipelineDetalle from './Components/LiquidacionPipelineDetalle';
import AuditoriaLiquidaciones from './Components/AuditoriaLiquidaciones';

export default class AdmLiquidaciones extends React.Component {
    render() {
        return (
            <div>
                <Routes>
                    <Route path="" element={<ListLiquidaciones />} />
                    <Route path="Nueva" element={<LiquidacionNew />} />
                    <Route path="Editar/:id/:idSeller" element={<EditarLiquidacion />} />
                    <Route path="EditarBorrador/:id/:idSeller" element={<EditarLiquidacionBorrador />} />
                    <Route path="FeeLogistico" element={<ActualizacionMasivaLiquidaciones/>}/>
                    <Route path="NuevoFee" element={<FeeNew/>}/>
                    <Route path="Comprobantes" element={<ComprobantesLiquidaciones />} />
                    <Route path="Pipelines" element={<LiquidacionesPipelinesDashboard />} />
                    <Route path="Pipelines/:idLiquidacion" element={<LiquidacionPipelineDetalle />} />
                    <Route path="Auditoria" element={<AuditoriaLiquidaciones />} />
                </Routes>
            </div>
        );
    }
}
